import React, { useState } from 'react';
import axios from 'axios';
import PopModal from '../../Constant/Custom/Models/PopModal';
import { serverUrl } from '../../Constant/Static/config';
import warningIcon from './../../Constant/Icons/warning.svg';
// import closeIcon from './../../Constant/Icons/close-circle.svg';
import Incorrect from './../../Constant/Icons/Incorrect.svg';
import correct from './../../Constant/Icons/correct.svg';
import AddUser from '../../Constant/Icons/adduser.svg';
import VerifierHeader from '../Components/VerifierHeader';

function VerifierRegistration() {
  const [formData, setFormData] = useState({
    name: { value: '', isValid: true },
    email: { value: '', isValid: true },
    mobile: { value: '', isValid: true },
    password: { value: '', isValid: true },
    confirm_password: { value: '', isValid: true },
  });

  const regex = {
    mobile: /^[6-9]\d{9}$/,
    email: /^(?=.*[a-zA-Z0-9._%+-]+@(?:gmail|yahoo)\.com$).*$/,
  };

  const [passwordCheck, setPasswordCheck] = useState({
    lengthCheck: { pattern: 7, isValid: false },
    numberCheck: { pattern: /.*[0-9].*/, isValid: false },
    lowercaseCheck: { pattern: /.*[a-z].*/, isValid: false },
    uppercaseCheck: { pattern: /.*[A-Z].*/, isValid: false },
    specialCharCheck: { pattern: /.*[!@#$%^&*()_+-=[\]{};':"\\|,.<>/?].*/, isValid: false },
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });
  const [onConfirm, setOnConfirm] = useState(() => () => { });

  const onRegister = () => {
    window.location.href = '/cv/login';
  }

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const setDefaultForm = (e) => {
    setFormData({
      name: { value: '', isValid: true },
      email: { value: '', isValid: true },
      mobile: { value: '', isValid: true },
      password: { value: '', isValid: true },
      confirm_password: { value: '', isValid: true },
    });
  };


  const validateField = (e) => {
    const { name, value } = e.target;

    let isValid = false;
    if (name === 'name' && value.trim().length > 3) {
      isValid = true;
      // console.log('Valid');
    }
    if (name === 'email' && regex.email.test(value.trim())) {
      isValid = true;
      // console.log('Valid');
    }
    if (name === 'mobile' && regex.mobile.test(value.trim())) {
      isValid = true;
      // console.log('Valid');
    }
    if (name === 'password') {
      // console.log("comes");

      const isValidLength = value.trim().length >= 7;
      const containsNumber = /\d/.test(value.trim());
      const containsLowercase = /[a-z]/.test(value.trim());
      const containsUppercase = /[A-Z]/.test(value.trim());
      const containsSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value.trim());

      setPasswordCheck({
        ...passwordCheck,
        lengthCheck: { ...passwordCheck.lengthCheck, isValid: isValidLength },
        numberCheck: { ...passwordCheck.numberCheck, isValid: containsNumber },
        lowercaseCheck: { ...passwordCheck.lowercaseCheck, isValid: containsLowercase },
        uppercaseCheck: { ...passwordCheck.uppercaseCheck, isValid: containsUppercase },
        specialCharCheck: { ...passwordCheck.specialCharCheck, isValid: containsSpecialChar },
      });

      isValid = isValidLength && containsNumber && containsLowercase && containsUppercase && containsSpecialChar;
    }
    if (name === 'confirm_password') {
      isValid = value.trim() === formData.password.value.trim();
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: { value, isValid }
    }));
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    // let isValid = false;

    // Validation logic here

    if (name == "password") validateField(e);

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: {
        value,
        isValid: prevFormData[name]?.isValid  
      }
    }));

  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const dataToSend = {
      name: formData.name.value.trim(),
      email: formData.email.value.trim(),
      mobile: formData.mobile.value.trim(),
      password: formData.password.value.trim(),
    };

    try {
      const res = await axios.post(`${serverUrl}/api/cv/register`, dataToSend);
      if (res.status === 200) {

        setModalType({ icon: 'success', title: 'Success', text: 'Registration successful!' });
        openModal();
        setOnConfirm(() => onRegister);
        // console.log(`Registration successful.`);
      }
      else {
        // console.log(res.data);
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 400) {
          setModalType({ icon: 'warning', title: 'Warning', text: 'Applicant already registered.' });
          openModal();
          setOnConfirm(() => closeModal);
          setDefaultForm();
          // console.log("Error during registration: " + err.response.data.message);
        } else {
          setModalType({ icon: 'error', title: 'Error', text: 'An error occurred. Please try again.' });
          openModal();
          setOnConfirm(() => closeModal);
          setDefaultForm();
          // console.log("Error during registration: " + err.response.data);
        }
      } else {
        // Handle network errors or other issues
        setModalType({ icon: 'error', title: 'Error', text: 'An error occurred. Please try again.' });
        openModal();
        setOnConfirm(() => closeModal);
        setDefaultForm();
        // console.log("Error during registration: " + err.message);
      }
    }
  };

  const handleCancel = async () => {
    window.location.reload();
  }

  return (
    <div>
      <VerifierHeader />
      <div>
        <form className='form-container' onSubmit={handleSubmit} >
          <div className='section-one'>
            <div style={{
              position: 'sticky',
              top: 0,
              backgroundColor: '#fff',
              display: 'flex',
              alignItems: 'center',
              // padding: ' 1% 0% 1% 5%',
              paddingLeft: '5%',
              '-webkit-sticky': 'top',
              'sticky': 'top',
              zIndex: 10,
              borderBottom: '1px solid #E2DFD2'
            }}>
              <h4 style={{ display: 'flex', alignItems: 'center', color: '#1C274C' }}>
                <img src={AddUser} alt='wrong' width={25} height={25} />
                &ensp; CV Registration
              </h4>
            </div>
            <div className='form-row'>
              <div className='label-container'>
                <label>Verification Officer Name</label>
                <p className='label-tamil'>(பெயர்)</p>
              </div>
              <input
                className={formData.name.isValid ? 'valid' : 'not-valid'}
                type="text"
                name="name"
                value={formData.name.value}
                onBlur={validateField}
                onChange={handleChange}
                placeholder='Enter Verification Officer Name'
                required
              />
              <span>e.g., ARAVIND S</span>
            </div>
            {!formData.name.isValid && (
              <div className='mobile-error'>
                <img src={warningIcon} alt='wrong' width={20} height={20} />
                <span>Enter a valid name..!</span>
              </div>
            )}
            <div className='form-row'>
              <div className='label-container'>
                <label>Email ID</label>
                <p className='label-tamil'>(மின்னஞ்சல் முகவரி)</p>
              </div>
              <input
                className={formData.email.isValid ? 'valid' : 'not-valid'}
                type="email"
                name="email"
                value={formData.email.value}
                onBlur={validateField}
                onChange={handleChange}
                placeholder='Enter Email ID'
                required
              />
              <span>e.g., aravind82ss@gmail.com</span>
            </div>
            {!formData.email.isValid && (
              <div className='mobile-error'>
                <img src={warningIcon} alt='wrong' width={20} height={20} />
                <span>Enter a valid email ID</span>
              </div>
            )}
            <div className='form-row'>
              <div className='label-container'>
                <label>Mobile Number</label>
                <p className='label-tamil'>(கைப்பேசி எண்)</p>
              </div>
              <input
                className={formData.mobile.isValid ? 'valid' : 'not-valid'}
                type="text"
                name="mobile"
                value={formData.mobile.value}
                onBlur={validateField}
                onChange={handleChange}
                placeholder='Enter Mobile Number'
                required
              />
              <span>e.g., 9600394883</span>
            </div>
            {!formData.mobile.isValid && (
              <div className='mobile-error'>
                <img src={warningIcon} alt='wrong' width={20} height={20} />
                <span>Enter valid mobile number</span>
              </div>
            )}
            <div className='form-row'>
              <div className='label-container'>
                <label>Password</label>
                <p className='label-tamil'>(கடவுச்சொல்லை உள்ளிடுக)</p>
              </div>
              <input
                className={formData.password.isValid ? 'valid' : 'not-valid'}
                type="password"
                name="password"
                value={formData.password.value}
                onBlur={validateField}
                onChange={handleChange}
                placeholder='Enter Password'
                required
              />
            </div>
            {!formData.password.isValid && (
              <div className='password-error'>
                <ul>
                  <li><img src={passwordCheck.lengthCheck.isValid ? correct : Incorrect} alt='wrong' width={15} height={15} />Password length should be greater than or equal to 7.</li>
                  <li><img src={passwordCheck.uppercaseCheck.isValid ? correct : Incorrect} alt='wrong' width={15} height={15} />Password should contain atleast one uppercase character.</li>
                  <li><img src={passwordCheck.lowercaseCheck.isValid ? correct : Incorrect} alt='wrong' width={15} height={15} />Password should contain atleast one lowercase character.</li>
                  <li><img src={passwordCheck.specialCharCheck.isValid ? correct : Incorrect} alt='wrong' width={15} height={15} />Password should contain atleast one special character.</li>
                  <li><img src={passwordCheck.numberCheck.isValid ? correct : Incorrect} alt='wrong' width={15} height={15} />Password should contain atleast one number.</li>
                </ul>
              </div>
            )}

            <div className='form-row'>
              <div className='label-container'>
                <label>Confirm Password</label>
                <p className='label-tamil'>(கடவுச்சொல்லை உறுதிசெய்க)</p>
              </div>
              <input
                className={formData.confirm_password.isValid ? 'valid' : 'not-valid'}
                type="password"
                name="confirm_password"
                value={formData.confirm_password.value}
                onBlur={validateField}
                onChange={handleChange}
                placeholder='Confirm Password'

                required
              />
            </div>
            {!formData.confirm_password.isValid && <div className='password-error'>
              <ul>
                <li><img src={Incorrect} alt='wrong' width={15} height={15} />Password doesn't match</li>
              </ul>
            </div>}
            <div className='register'>
              <input type='submit' value={'Register'} />
            </div>

          </div>
        </form>
      </div>
      <div>
        <PopModal
          isOpen={isModalOpen}
          onConfirm={onConfirm}
          type={modalType}
          onCancel={handleCancel}
        />
      </div>
    </div>
  )
}

export default VerifierRegistration;